import { useQConfig } from '@exam-management/feature-qconfig-provider';
import { QConfigStructureCategory } from '@exam-management/graphql';
import { useMemo } from 'react';

import {
  type QConfigStructureFormInput,
  QConfigStructureFormProvider,
  QConfigStructureModalProvider,
} from '../../providers';
import { QConfigStructureDetailForm } from '../qconfig-structure-detail-form';

export default function QConfigStructureDetail() {
  const {
    qConfigData: { structures },
  } = useQConfig();

  const initialFormValues = useMemo(() => {
    return structures
      .filter((item) => {
        if (item.category) {
          return [
            QConfigStructureCategory.Part,
            QConfigStructureCategory.Subject,
            QConfigStructureCategory.Chapter,
          ].includes(item.category);
        }
        return false;
      })
      .reduce((acc, item) => {
        acc[item.id] = item.name ?? '';
        return acc;
      }, {} as QConfigStructureFormInput);
  }, [structures]);

  return (
    <QConfigStructureFormProvider initialValues={initialFormValues}>
      <QConfigStructureModalProvider>
        <QConfigStructureDetailForm />
      </QConfigStructureModalProvider>
    </QConfigStructureFormProvider>
  );
}
